{
  "name": "Nombre",
  "accountType": "Tipo de cuenta",
  "portfolio": "Cartera",
  "percentageOfTotalGOAL": "% del objetivo total",
  "percentageOfTotalACCOUNT": "% del total de la cuenta",
  "balance": "Saldo",
  "addSubAccount": "Añadir",
  "subAccount": "Subcuentas",
  "noLinkedSubAccountToACCOUNT": "No tiene ninguna subcuenta vinculada a esta cuenta",
  "noLinkedSubAccountToGOAL": "No tiene ninguna subcuenta vinculada a esta Meta",
  "reactivateSubAccount": "Reactivar subcuenta",
  "subAccountSuccessToast": "Has reactivado correctamente esta subcuenta.",
  "closeSubaccountModal": {
    "title": "Cerrar subcuenta",
    "body": "¿Está seguro de que desea cerrar esta subcuenta?",
    "close": "Cerrar",
    "cancel": "Cancelar"
  },
  "switchEquitiesModal": {
    "atCost": "Cambio de seguridad al costo",
    "atMarket": "Cambio de seguridad al precio de mercado",
    "close": "Cerrar",
    "cancel": "Cancelar",
    "existingHolding": "Cambiar salida de la seguridad",
    "newHolding": "Cambiar entrada en la seguridad",
    "date": "Cambiar la fecha",
    "description": "Descripción",
    "switch": "Cambiar",
    "errorToastMessage": "Las transacciones de cambio no se crearon.",
    "sameProductToastMessage": "El cambio de seguridad es igual que el cambio en la seguridad."
  },
  "editSwitchEquitiesModal": {
    "atCostTransactionsTitle": "Cambio de salida/entrada al costo",
    "atMarketTransactionsTitle": "Cambio de salida/entrada al precio de mercado",
    "subAccount": "Cartera",
    "date": "Fecha",
    "switchOutSecurity": "Cambiar salida de la seguridad",
    "switchInSecurity": "Cambiar entrada en la seguridad",
    "quantity": "Número total de unidades",
    "cost": "Costo base ajustado por unidad",
    "totalCost": "Costo total",
    "marketValuePerUnit": "Precio por unidad",
    "marketValue": "Valor total de mercado",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "invalidPriceToastMessage": "El precio no puede ser $0."
  },
  "status": "Estado",
  "Goal": "Meta",
  "Account": "Cuenta",
  "recommended": "Recomendado:",
  "close": "Cerrar",
  "subaccountStateLabel": "Estado de subcuenta",
  "owner": "Propietario"
}
